// extracted by mini-css-extract-plugin
export default {"result":"result_result__+BJUE"};